<template><svg viewBox="0 0 16 24"  xmlns="http://www.w3.org/2000/svg">
<path d="M6 24H0V0H6V24ZM16 0H10V24H16V0Z" />
</svg>
</template>